exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#audio-container[data-v-186cad44]{display:inline-block;vertical-align:middle;height:70px}#newSlideButton[data-v-186cad44]{font-size:45px;display:inline-block;vertical-align:top;margin:10px 0}.btn-md[data-v-186cad44]{font-size:22px;padding:12px 10px 0;position:relative;top:3px;color:#0072ba}", ""]);

// exports
